import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Col, Container, FormGroup, Input, Label, Modal, Row } from 'reactstrap';
import { ComboBox } from '../../../dropdowns';
import PropTypes from "prop-types";
import { FileDropzone } from '../../../FileDropzone';
import fileDownload from 'js-file-download';
import api from "../../../../services/api";
import Loader from '../../../loaders';

export default function JobOrderCandidateMilestoneDocumentDialog(props) {
    const {jobOrderCandidates, milestoneName, onClose, onSubmit} = props;
    const [loading, setLoading] = useState(false);
    const [itemInEdit, setItemInEdit] = useState({jobOrderCandidates, milestoneName, useTemplate: true, file: null});
    const [selectedTemplate, setSelectedTemplate] = useState(null);

    const positionId = useMemo(() => {
        const positionIds = [...new Set(jobOrderCandidates?.map(joc => joc.positionId) ?? [])];
        return positionIds.length === 1 ? positionIds[0] : null;
    }, [jobOrderCandidates]);

    const downloadAttachment = (fileInfo = null, downloadUrl = null) => {
        if (fileInfo && fileInfo instanceof File) {
            fileDownload(fileInfo, fileInfo.name);
            return;
        }

        if (!downloadUrl)
            return;

        setLoading(true);
        let url = downloadUrl;
        api.get(url, { responseType: 'blob' })
        .then(blob => {
            fileDownload(blob.data, fileInfo.filename);
        }).catch(error => {
            console.error(error)
        }).finally(() => setLoading(false))
    }

    const files = useMemo(() => {
        let name, size, file;

        if (!itemInEdit?.file)
            return null;

        name = itemInEdit.file.name;
        size = itemInEdit.file.size;
        file = itemInEdit.file;

        return <aside className="dropzone-list pt-3">
            <Label>Files</Label>
            <ul>
                <li key={name} className="pt-1">
                    <a onClick={() => downloadAttachment(file)}>{name} - {size} bytes</a>
                </li> 
            </ul>
        </aside>
    }, [ itemInEdit.file ]);

    const validateDocument = useCallback(() => {
        if (!itemInEdit?.file)
            return;

        onSubmit(itemInEdit);
    }, [itemInEdit]);

    return (
        <Modal
            isOpen={true}
        >
        {
            loading && <Loader />
        }
            <div className="modal-header">
                <h5 className="modal-title">Milestone Document - {itemInEdit?.jobOrderCandidates?.map(joc => joc.candidateName).join(", ")}</h5>
                <button
                    aria-label="Close"
                    className="close"
                    onClick={onClose}
                    type="button"
                >
                    <span aria-hidden={true}><i className="fas fa-times-circle" /></span>
                </button>
            </div>
            <div className="modal-body">
                <Container fluid className="px-0">
                    <Row>
                        <Col md={12} className="border-right border-black">
                            <FormGroup className="mb-3 pb-3 border-bottom-3">
                                <h6 className="modal-title">{itemInEdit?.milestoneName ?? ""}</h6>
                            </FormGroup>
                        </Col>
                    {
                        positionId ?
                        <Col md={12} className="border-right border-black">
                            <FormGroup className="mb-3 pb-3 border-bottom-3">
                                <Label>
                                    Select Interview Template to download
                                </Label>
                                <ComboBox
                                    minLength={0}
                                    isLookup={false}
                                    idField="milestoneDocumentId"
                                    valueField="templateName"
                                    endpoint={`/milestonedocument/${positionId}/position`}
                                    selectedItem={selectedTemplate}
                                    onChange={(item) => {
                                        setSelectedTemplate(item);
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        :
                        null
                    }
                    {
                        selectedTemplate ?
                        <Col xs={12} className="m-0 p-0">
                            <ul style={{ listStyleType: 'none' }}>
                                <li className="pt-1">
                                    <a className="cursor-pointer font-size-small-custom" onClick={() => downloadAttachment(selectedTemplate, `milestonedocument/${selectedTemplate.milestoneDocumentId}/download`)}><i className="fas fa-download mr-2" />{selectedTemplate.templateName} ({selectedTemplate.filename})</a>
                                </li> 
                            </ul>
                        </Col>
                        :
                        null
                    }
                        <FileDropzone
                            files={files}
                            onDrop={([file]) => {
                                setItemInEdit({ ...itemInEdit, file });
                            }}
                            maxFiles={1}
                        />
                    </Row>
                </Container>
            </div>
            <div
                className="modal-footer"
            >
                <Button
                    color="secondary"
                    onClick={onClose}
                    type="button"
                >
                    Close
                </Button>
                <Button
                    color="default"
                    onClick={() => validateDocument()}
                    type="button"
                    disabled={!itemInEdit?.file}
                >
                    Submit
                </Button>
            </div>
        </Modal>
    );
}

JobOrderCandidateMilestoneDocumentDialog.propTypes = {
    jobOrderCandidates: PropTypes.array.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}